export default __webpack_public_path__ + "edb06969089e2d3f436922a0530355bf.png";